import React from "react";

import Layout from "./components/shared/Layout";

import Home from "./pages/home/Page";
import ProfTest from "./pages/proftest/Page";
import HollandResults from "./pages/holland-results/Page";
import JobMarket from "./pages/job-market/Page";
import JobMarketAllPages from "./pages/job-market/AllPages";
//import Search from "./pages/search/Page";

import { routes as PersonalRoutes } from "@areas/shared/pages/personal/PageRoutes";

import { fetchWrapper } from "@helpers/fetchwrapper";

export const routes = [
  {
    path: "",
    element: <Layout />,
    errorElement: <Layout error={true} />,
    children: [
      {
        path: "",
        element: <Home />,
        loader: async () => {
          return fetchWrapper.get(
            `/v1/api/app/mainPageDataAdvanced?climit=2&plimit=6&rlimit=6&elimit=5&type=collegesAndInstitutions`
          );
        },
      },
      {
        path: "rynok-truda",
        element: <JobMarket />,
      },
      {
        path: "rynok-truda/vse",
        element: <JobMarketAllPages />,
      },
    ],
  },
  {
    path: "personal",
    children: PersonalRoutes,
  },
  {
    path: "proftest",
    element: <ProfTest></ProfTest>,    
  },
  {
    path: "holland-results",
    element: <HollandResults />,
  },
];
